export default {
  "content": "<path d=\"M29.965 1H2.035C1.462 1 1 1.448 1 2v38h30V2c0-.552-.463-1-1.035-1z\" fill=\"#fff\"/><path d=\"M1 40V2c0-.552.463-1 1.034-1h27.931C30.537 1 31 1.448 31 2v38\" stroke=\"#1D1D1B\"/><path d=\"M5.551 18.6h12.316M23.655 18.6h2.823M5.551 25.6h12.316M23.655 25.6h2.823M5.551 32.6h12.316M23.655 32.6h2.823\" stroke=\"#1D1D1B\" stroke-width=\".8\" stroke-linecap=\"round\"/><path d=\"M5.573 11.578h20.852\" stroke=\"#1D1D1B\" stroke-width=\".843\" stroke-linecap=\"round\"/>",
  "attrs": {
    "width": "32",
    "height": "40",
    "viewBox": "0 0 32 40",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};